import { render, staticRenderFns } from "./YesNoNotesFilesWidget.vue?vue&type=template&id=8504291e"
import script from "./YesNoNotesFilesWidget.vue?vue&type=script&lang=js"
export * from "./YesNoNotesFilesWidget.vue?vue&type=script&lang=js"
import style0 from "./YesNoNotesFilesWidget.vue?vue&type=style&index=0&id=8504291e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports